import { styled } from '@mui/material';
import { Button } from './Button';

export const MobileButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    minHeight: '32px',
    paddingTop: '4px',
    paddingBottom: '4px',
    lineHeight: '20px',
  },
}));
